/** Microsoft-Graph-Zugriff — Pendant zu `Client/Services/Graph/GraphUserService.cs`. */

import { DEMO_COMPANY, isDemoMode } from '@/auth/demoAccount';
import { DEFAULT_PROFILE_IMAGE } from '@/assets/defaultProfileImage';
import { bytesToBase64 } from '@/utils/file';

import { graphClient } from './httpClient';

interface GraphMe {
  companyName?: string | null;
}

export const graphApi = {
  /** 240x240-Profilbild als data-URL; bei Fehler das Standardbild. */
  async getProfileImage(): Promise<string> {
    // Ohne echte Anmeldung gibt es kein Graph-Token; der Aufruf liefe in einen 401.
    if (isDemoMode) {
      return DEFAULT_PROFILE_IMAGE;
    }

    try {
      const response = await graphClient.raw('GET', '/v1.0/me/photos/240x240/$value');
      if (!response.ok) {
        return DEFAULT_PROFILE_IMAGE;
      }
      const bytes = new Uint8Array(await response.arrayBuffer());
      return `data:image/jpeg;base64,${bytesToBase64(bytes)}`;
    } catch {
      return DEFAULT_PROFILE_IMAGE;
    }
  },

  /** `companyName` oder `"Externer Benutzer"`. */
  async getCompanyName(): Promise<string> {
    if (isDemoMode) {
      return DEMO_COMPANY;
    }

    try {
      const me = await graphClient.get<GraphMe | null>('/v1.0/me?$select=companyName');
      const companyName = me?.companyName;
      return companyName === undefined || companyName === null || companyName.length === 0
        ? 'Externer Benutzer'
        : companyName;
    } catch {
      return 'Externer Benutzer';
    }
  },
};
